<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-select v-model="listQuery.exam_id" clearable placeholder="请选择" @change="getData">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试科目:">
          <el-select v-model="listQuery.subject_id" clearable placeholder="请选择">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="考生名称:">
          <el-input v-model="listQuery.name" clearable placeholder="考生名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column  prop="name"  label="考试名称">
      </el-table-column>
      <el-table-column prop="subject_name" label="考试项目">
      </el-table-column>
      <el-table-column prop="student_name" label="考生姓名">
      </el-table-column>
      <el-table-column prop="begin_dt" label="应开始时间">
      </el-table-column>
      <el-table-column prop="end_dt" label="应结束时间">
      </el-table-column>

    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page"
                  @pagination="getData"/>

    </div>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                student: {},
                examList: [],
                subjectList: [],
                total: 0,
                dialogType: 'new',
                dialogVisible: false,
                listQuery: {
                    page: 1,
                    per_page: 20,
                },
                tableData: []
            };
        },
        computed: {},
        created() {
            this.getData();
            this.getExam();
        },
        methods: {
            getExam() {
                this.$http.examsList({page_size: 100000}).then(res => {
                    this.examList = res.data;
                })
            },
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            getData() {
                this.$http.getExamMiss(this.listQuery)
                    .then(res => {
                        this.tableData = res.data;
                        this.subjectList = res.subject;
                        this.total = res.meta.total;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/examManage/examMiss.vue